import { useTranslation } from 'react-i18next'
import { FiSearch, FiRotateCw } from 'react-icons/fi'
import { DigitMode } from '../../../BetLotto.types'
import { IoClose } from 'react-icons/io5'

const DEFAULT_MAX_LENGTH = 3

const DIGIT_MODE_MAX_LENGTH: Partial<Record<DigitMode, number>> = {
  [DigitMode.TWO_DIGIT]: 2,
  [DigitMode.THREE_DIGIT]: 3,
  [DigitMode.RUNNING]: 1,
}

interface SearchAndRotationProps {
  digitMode: DigitMode
  searchQuery?: string
  onSearchChange: (value: string) => void
  onRotateClick?: () => void
  isRotated?: boolean
  isDisabled?: boolean
}

const SearchAndRotation: React.FC<SearchAndRotationProps> = ({
  digitMode,
  searchQuery = '',
  onSearchChange,
  onRotateClick,
  isRotated,
  isDisabled,
}) => {
  const { t } = useTranslation()

  const getMaxLength = () =>
    DIGIT_MODE_MAX_LENGTH[digitMode] ?? DEFAULT_MAX_LENGTH

  return (
    <div className="flex gap-3 mb-6">
      <div className="relative flex-1">
        <FiSearch
          className="absolute left-3 top-1/2 -translate-y-1/2 text-[var(--search-placeholder)]"
          size={20}
        />
        <input
          type="text"
          className="w-full pl-10 pr-10 py-3 rounded-lg border font-semibold text-base bg-[var(--search-bg)] text-[var(--search-text)] border-[var(--search-border)] placeholder-[var(--search-placeholder)] focus:outline-none focus:border-[var(--search-focus-border)]"
          placeholder={t('lottoSearch.searchNumber')}
          value={searchQuery}
          maxLength={getMaxLength()}
          pattern="[0-9]*"
          inputMode="numeric"
          onChange={(e) => {
            const value = e.target.value.replace(/[^0-9]/g, '')
            onSearchChange(value)
          }}
        />
        {searchQuery && (
          <button
            type="button"
            onClick={() => onSearchChange('')}
            className="absolute right-3 top-1/2 -translate-y-1/2 w-auto cursor-pointer text-center"
          >
            <div className="h-5 w-5 rounded-full flex items-center justify-center bg-[var(--betcontrols-remove)] hover:bg-[var(--betcontrols-remove-hover)] transition-colors">
              <IoClose size={14} className="text-[var(--color-primary-50)]" />
            </div>
          </button>
        )}
      </div>
      {!isDisabled && (
        <button
          type="button"
          onClick={onRotateClick}
          className={`px-4 py-3 rounded-lg border font-semibold text-base transition-all cursor-pointer bg-[var(--bet-type-bg)] text-[var(--bet-type-text)] border-[var(--bet-type-border)] hover:bg-[var(--bet-type-hover-bg)] hover:text-[var(--bet-type-hover-text)] hover:border-[var(--bet-type-hover-border)] flex items-center gap-2 ${
            isRotated
              ? 'btn-active-state border-[var(--bet-type-active-border)]'
              : ''
          }`}
        >
          <FiRotateCw size={20} />
          <span>{t('layout.lottoBetTab.rotateNumber')}</span>
        </button>
      )}
    </div>
  )
}

export default SearchAndRotation
